import { Link } from 'react-router-dom';
import { getRandomImage, isAdmin } from '../../hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { inIframe } from '../../utils';

const handleImageError = (e) => {
  e.target.src = getRandomImage();
};

export const UserCoursesBox = ({
  userCourses,
  userCoursesLoaded,
  username = '',
                                 showDiscoverBlock=true
}) => {
  const { t } = useTranslation('library');
  const renderCourses = ({ courseData, imageUrl }) => {
    return (
      <>
        <div className="div-block-411">
          <img
            alt=""
            className="image-155"
            loading="lazy"
            onError={handleImageError}
            sizes="(max-width: 767px) 234px, (max-width: 991px) 295.734375px, (max-width: 1279px) 21vw, 226.5px"
            src={imageUrl}
          />
          <div className="label c">
            <div className="text-block-294">{t('COURSE')}</div>
          </div>
        </div>
        <div className="item-body">
          <div className="div-block-417">
            <div className="div-block-461">
              <img
                alt=""
                className="image-167"
                loading="lazy"
                sizes="100vw"
                src="images/google.png"
                srcSet="images/google-p-500.png 500w, images/google.png 512w"
              />
            </div>
            <div className="text-block-235">{t('Google')}</div>
            <div className="div-block-523">
              <div className="text-block-233">{t('120 Skill Coins')}</div>
            </div>
          </div>
          <div className="text-block-225">
            {courseData?.course?.course_name}
          </div>
          <div className="div-block-470">
            <div className="text-block-273">
              <span className="skill_span">{t('Computer Programming')}</span>
              <span className="skill_span">{t('Python Libraries')}</span>
              <span className="skill_span last">{t('Python Programming')}</span>
            </div>
          </div>
          <div className="div-block-387">
            <img
              alt=""
              className="image-184"
              loading="lazy"
              sizes="100vw"
              src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
              srcSet="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
            />
            <div className="text-block-241">(1k+)</div>
          </div>
          <div className="div-block-389">
            <div className="text-block-287">
              <strong className="bold-text-7 p"> </strong>
              <span className="bullet">
                <strong className="bold-text-7"></strong>
              </span>
              <strong className="bold-text-7"></strong>
            </div>
            <div className="item_options">
              <div className="item_options_triger">
                <img
                  alt=""
                  className="image-182"
                  loading="lazy"
                  src="images/menu_1menu.png"
                />
              </div>
              <div className="options_div">
                <div className="text-block-238">{t('Add to Pathway')}</div>
                <div className="text-block-238">{t('Save for Later')}</div>
                <div className="text-block-238">{t('Dismiss')}</div>
                <div className="text-block-238">{t('Share')}</div>
                <div className="text-block-238">{t('Create a Pathway')}</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {!inIframe() && showDiscoverBlock &&
        (!isAdmin() ||
          process.env.REACT_APP_IBL_APP_ENABLE_CREATE_BUTTONS !== 'true') && (
          <div
            id="w-node-f31e1962-462b-8b0d-0045-72a4bb836b6c-a52aa012"
            className="item-box path_box custom_box" style={{
            minHeight:"200px"
          }}
          >
            <Link to="/discover" className="link-block-31 w-inline-block">
              <div className="div-block-444">
                <div className="div-block-394">
                  <img
                    src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66babee_plus.png"
                    loading="lazy"
                    alt=""
                    className="image-142"
                  />
                </div>
                <div className="c_p">{t('Discover Courses')}</div>
              </div>
            </Link>
          </div>
        )}
      {isAdmin() &&
        !inIframe() &&
        process.env.REACT_APP_IBL_APP_ENABLE_CREATE_BUTTONS === 'true' && (
          <div
            id="w-node-f31e1962-462b-8b0d-0045-72a4bb836b6c-a52aa012"
            className="item-box path_box custom_box" style={{
              minHeight:"200px"
          }}
          >
            <Link
              to={`${process.env.REACT_APP_IBL_STUDIO_URL}`}
              className="link-block-31 w-inline-block"
            >
              <div className="div-block-444">
                <div className="div-block-394">
                  <img
                    src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66babee_plus.png"
                    loading="lazy"
                    alt=""
                    className="image-142"
                  />
                </div>
                <div className="c_p">{t('Create Course')}</div>
              </div>
            </Link>
          </div>
        )}
      {userCoursesLoaded &&
        userCourses.map((courseData, index) => {
          const imageUrl =
            process.env.REACT_APP_IBL_LMS_URL +
            courseData?.metadata?.course_image_asset_path;

          return (
            <div
              key={index}
              className="item-box path_box"
              id={`w-node-_9d122df3-5436-acb4-d16f-30b76ec43f9d-27264aa9`}
            >
              {!inIframe() ? (
                <Link
                  className="link-block-31 w-inline-block"
                  to={`/courses/${courseData?.course?.course_id}`}
                >
                  {renderCourses({ courseData, imageUrl })}
                </Link>
              ) : (
                <a
                  className="link-block-31 w-inline-block"
                  href={`${process.env.REACT_APP_IBL_SPA_SKILLS_URL}/courses/${courseData?.course?.course_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {renderCourses({ courseData, imageUrl })}
                </a>
              )}
            </div>
          );
        })}
    </>
  );
};
